import React, { useEffect, useState } from "react";
import Select from "react-select";

const SaudiRegionsAndCities = ({ onLocationChange, handleChange, branchData, companyData }) => {
  const [regions] = useState([
    { id: 1, name: "الرياض", cities: ["الرياض", "الدرعية", "الخرج", "الزلفي", "المجمعة", "وادي الدواسر", "شقراء", "حوطة بني تميم", "الأفلاج", "السليل", "رماح", "الحريق", "الغاط"] },
    { id: 2, name: "مكة المكرمة", cities: ["مكة المكرمة", "جدة", "الطائف", "رابغ", "الليث", "القنفذة", "خليص", "الكامل", "المويه", "ميسان", "أضم"] },
    { id: 3, name: "المدينة المنورة", cities: ["المدينة المنورة", "ينبع", "العلا", "بدر", "خيبر", "الحناكية", "المهد", "وادي الفرع"] },
    { id: 4, name: "القصيم", cities: ["بريدة", "عنيزة", "الرس", "البكيرية", "المذنب", "رياض الخبراء", "البدائع", "عيون الجواء", "النبهانية", "الشماسية", "ضريه"] },
    { id: 5, name: "الشرقية", cities: ["الدمام", "الخبر", "الأحساء", "الجبيل", "القطيف", "الخفجي", "النعيرية", "حفر الباطن", "رأس تنورة", "بقيق", "قرية العليا", "العديد"] },
    { id: 6, name: "عسير", cities: ["أبها", "خميس مشيط", "بيشة", "النماص", "محايل", "رجال ألمع", "ظهران الجنوب", "أحد رفيدة", "بلقرن", "تنومة", "البرك", "طريب"] },
    { id: 7, name: "تبوك", cities: ["تبوك", "الوجه", "ضباء", "حقل", "أملج", "تيماء"] },
    { id: 8, name: "حائل", cities: ["حائل", "بقعاء", "الغزالة", "الشنان", "الحائط", "السليمي", "الشملي", "موقق"] },
    { id: 9, name: "الحدود الشمالية", cities: ["عرعر", "رفحاء", "طريف", "العويقيلة"] },
    { id: 10, name: "جازان", cities: ["جازان", "صبيا", "أبو عريش", "صامطة", "بيش", "الدرب", "العارضة", "فرسان", "أحد المسارحة", "الحرث", "ضمد", "الريث", "فيفاء"] },
    { id: 11, name: "نجران", cities: ["نجران", "شرورة", "حبونا", "بدر الجنوب", "يدمة", "ثار", "خباش", "سلطانة"] },
    { id: 12, name: "الباحة", cities: ["الباحة", "بلجرشي", "المندق", "المخواة", "قلوة", "العقيق", "القرى", "غامد الزناد", "الحجرة"] },
    { id: 13, name: "الجوف", cities: ["سكاكا", "القريات", "دومة الجندل", "طبرجل"] },
  ]);

  const dataSource = companyData || branchData || {};

  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  useEffect(() => {
    if (dataSource.state) {
      const region = regions.find((r) => r.name === dataSource.state);
      if (region) {
        setSelectedRegion({ value: region.id, label: region.name });
      }
    }
    if (dataSource.city) {
      setSelectedCity({ value: dataSource.city, label: dataSource.city });
    }
  }, [dataSource.state, dataSource.city, regions]);

  const handleRegionChange = (option) => {
    setSelectedRegion(option);
    setSelectedCity(null);
    handleChange("state", option ? option.label : "");
  };

  const handleCityChange = (option) => {
    setSelectedCity(option);
    handleChange("city", option ? option.label : "");
  };

  const regionOptions = regions.map((region) => ({
    value: region.id,
    label: region.name,
  }));

  const cityOptions = selectedRegion
    ? regions
        .find((region) => region.id === selectedRegion.value)
        .cities.map((city) => ({
          value: city,
          label: city,
        }))
    : [];

  return (
    <>
      {/* اختيار المنطقة */}
      <div className="col-lg-4 mb-2 area">
        <div>
          <label>المنطقة</label>
          <Select
            value={selectedRegion}
            options={regionOptions}
            onChange={handleRegionChange}
            id="state"
            name="state"
            placeholder="اختر المنطقة"
            isSearchable
            isClearable
            classNames={{
              control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
            }}
          />
        </div>
      </div>

      {/* اختيار المدينة */}
      <div className="col-lg-4 mb-2 city">
        <div>
          <label>المدينة</label>
          <Select
            value={selectedCity}
            options={cityOptions}
            onChange={handleCityChange}
            id="city"
            placeholder="اختر المدينة"
            isSearchable
            isClearable
            isDisabled={!selectedRegion}
            classNames={{
              control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
            }}
          />
        </div>
      </div>

      {/* العنوان */}
      <div className="col-lg-4 mb-2">
        <div>
          <label htmlFor="address">العنوان</label>
          <input type="text" value={dataSource.address || companyData?.address} onChange={(e) => handleChange("address", e.target.value)} placeholder="العنوان" id="address" className="form-control" />
        </div>
      </div>

      {/* الموقع */}
      <div className="col-12">
        <div>
          <label htmlFor="location">الموقع</label>
          <input type="text" value={dataSource.location || companyData?.location } onChange={(e) => handleChange("location", e.target.value)} placeholder="الموقع" id="location" className="form-control" />
        </div>
      </div>
    </>
  );
};

export default SaudiRegionsAndCities;
